<template>
  <div class="qc-platform-ui">
    <div :class="'qc-playform-modal qc-login-form-modal ' + ('qc-login-form-' + curLoginWay)">
      <div class="qc-modal-warp" v-if="!forgotPasswordShow">
        <div class="qc-playform-overlay"></div>
        <div class="qc-playform-layout" v-show="showLoginPopup">
          <Header closeBtnIcon="close_btn" :closeHandle="closeLogin" />
          <div class="qc-playform-content qc-login-content">
            <Tab
              :loginWays="loginWays"
              :curLoginWay="curLoginWay"
              :toggleLoginWay="toggleLoginWay" />
            <div class="qc-playform-form">
              <AccountForm
                :show="curLoginWay === LOGIN_TYPE.ACCOUNT"
                :isAgreement="isAgreement"
                :accountCache="accountCache"
                :onChangeAccountCache="onChangeAccount"
                :openWarmTip="openWarmTip"
                :onFinish="props.onFinish"
                :autoDown="props.autoDownConfig.account" />
              <SMSForm
                :show="curLoginWay === LOGIN_TYPE.PHONE"
                :isAgreement="isAgreement"
                :accountCache="accountCache"
                :onChangeAccountCache="onChangeAccount"
                :openWarmTip="openWarmTip"
                :onFinish="props.onFinish"
                :autoDown="props.autoDownConfig.sms" />
              <!-- <ChannelForm
                :show="curLoginWay === LOGIN_TYPE.CHANNEL"
                :isAgreement="isAgreement"
                :openWarmTip="openWarmTip"
                :onFinish="props.onFinish"
                :autoDown="props.autoDownConfig.channel" /> -->
            </div>
          </div>
          <div class="qc-login-footer">
            <span @click="onOpenForgotPassword()">忘记密码?</span>
          </div>
          <!-- <div v-if="curLoginWay !== LOGIN_TYPE.CHANNEL" class="qc-login-footer">
            <span @click="onOpenForgotPassword()">忘记密码?</span>
          </div> -->
        </div>
        <div class="qc-warm-reminder" v-show="showWarmTip">
          <div class="qc-warm-title">
            温馨提示
          </div>
          <div class="qc-warm-content">
            <div class="qc-warm-text">
              请阅读并同意青瓷游戏的<a 
              :href="AGREEMENT.SERVICE" target="_blank">{{ AGREEMENT.SERVICE_LABEL }}</a>、<a 
              :href="AGREEMENT.PRIVACY" target="_blank">{{ AGREEMENT.PRIVACY_LABEL }}</a>、<a 
              :href="AGREEMENT.CHILD_PRIVACY" target="_blank">{{ AGREEMENT.CHILD_PRIVACY_LABEL }}</a>、<a 
              :href="AGREEMENT.TELECOM" target="_blank">{{ AGREEMENT.TELECOM_LABEL }}</a>
            </div>
          </div>
          <div class="qc-warm-btns">
            <div class="qc-default-btn qc-cancel-btn" @click="closeWarmTip()">不同意</div>
            <div class="qc-default-btn qc-confirm-btn" @click="onAgreement()">同意并继续</div>
          </div>
        </div>
      </div>
      <!-- 忘记密码弹窗 -->
      <ForgotPassword
        :show="forgotPasswordShow"
        :onClose="onColseForgotPassword" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import Tab from './Tab.vue';
import AccountForm from './Account.vue';
// import ChannelForm from './Channel.vue';
import SMSForm from './SMS.vue';
import ForgotPassword from './ForgotPassword.vue';
import Header from '../../subComponents/Header/index.vue';
import { loadScript } from '../../core/utils/index';
import { LOGIN_TYPE, AGREEMENT } from '../../core/constants/index';
import type { DomesticLoginProps } from '../types';

const props = withDefaults(defineProps<DomesticLoginProps>(), {});
const showLoginPopup = ref(true);
const showWarmTip = ref(false);
const isAgreement = ref(false);
const accountCache = ref('');

const loginWays = props.loginWays;
const curLoginWay = ref(loginWays[0]);

const openWarmTip = () => {
  showWarmTip.value = true;
  showLoginPopup.value = false;
  isAgreement.value = false;
};
const closeWarmTip = () => {
  showWarmTip.value = false;
  showLoginPopup.value = true;
};
const closeLogin = () => {
  accountCache.value = "";
  props.onClose();
};
const onChangeAccount = (val: string) => {
  accountCache.value = val;
};

const onAgreement = () => {
  isAgreement.value = true;
  closeWarmTip();
};
const toggleLoginWay = (item: number) => {
  if (item === curLoginWay.value) return;
  curLoginWay.value = item;
  isAgreement.value = false;
};

const forgotPasswordShow = ref(false);
const onColseForgotPassword = () => {
  forgotPasswordShow.value = false;
};
const onOpenForgotPassword = () => {
  forgotPasswordShow.value = true;
};

// 初始化阿里云二次验证脚本
const initAliyunCaptchaScript = async () => {
  window.AliyunCaptchaConfig = { region: "cn", prefix: "haeb3b" };
  await loadScript('https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js', 'aliyunCaptchaSDK');
};

// 页面加载完成
onMounted(() => {
  // 初始化第三方登录插件
  initAliyunCaptchaScript();
});

</script>
<style lang="less"></style>